import { createAsyncThunk, createSlice } from "@reduxjs/toolkit";
import { apiClient } from "../../api";
import { getServicesData, getExperiencesData } from "../../utils/home-util";
import { getFooterList } from "../../utils/quiz-util";

export const getExperiencesDatareq = createAsyncThunk(
  "getExperiencesDatareq",
  async (res) => {
    const responce = await getExperiencesData(res);
    return responce.data;
  }
);

export const getServicesDatareq = createAsyncThunk(
  "getServicesDatareq",
  async (res) => {
    const responce = await getServicesData(res);
    return responce.data;
  }
);

export const getFooterDatareq = createAsyncThunk(
  "getFooterDatareq",
  async (res) => {
    const responce = await getFooterList(res);
    return responce.data;
  }
);
const initialState = {
  quickLinks: ["Home", "Services", "Experiences", "Destinations", "About"],
  experiences: [
    "Celebration (Anniversary, Birthday)",
    "Exploration",
    "Relaxation",
    "Healing & Wellness",
    "Heritage/Cultural Connection",
    "Professional/Workation",
    "Bucket List Dream",
    "Bonding with Family or Partner",
    "Weekend Getaway",
    "Honeymoon",
  ],
  // transportation: [
  //   'Flights',
  //   'Trains',
  //   'Self-Drive',
  //   'Chauffeur',
  //   'Helicopter or small aircraft'
  // ],
  // company: [
  //   'About Blue Diamond Voyage',
  //   'Careers',
  //   'Success Stories',
  //   'Partner Program',
  //   'Press & Media',
  //   'Terms & Conditions',
  //   'Privacy Policy'
  // ],
  contacts: [],
  status: "idle",
  loading: false
};

export const loadFooter = createAsyncThunk("footer/load", async () => {
  const data = await apiClient.get("/footer");
  return data.data;
});

const footerSlice = createSlice({
  name: "footer",
  initialState,
  reducers: {},
  extraReducers: (builder) => {
    builder
      .addCase(loadFooter.pending, (state) => {
        state.status = "loading";
      })
      .addCase(loadFooter.fulfilled, (state, action) => {
        state.status = "succeeded";
        const data = action.payload || {};
        Object.assign(state, { ...state, ...data });
      })
      .addCase(loadFooter.rejected, (state) => {
        state.status = "failed";
      })
      .addCase(getServicesDatareq.fulfilled, (state, action) => {
        state.loading = false;
        const sections = action.payload?.sections
          ?.slice()
          .sort((a, b) => a.sort_order - b.sort_order);

        const list = sections[1]?.lists;
        const sortedList = list
          .slice()
          .sort((a, b) => a.sort_order - b.sort_order);
        state.servicesPageData = sortedList.map((item) => item.title);
        state.error = null;
      })
      .addCase(getExperiencesDatareq.fulfilled, (state, action) => {
        state.loading = false;
        const sections = action.payload?.sections
          ?.slice()
          .sort((a, b) => a.sort_order - b.sort_order);

        const list = sections[1]?.lists;
        const sortedList = list
          .slice()
          .sort((a, b) => a.sort_order - b.sort_order);
        state.experiencesPageData = sortedList.map((item) => item.title);
        state.error = null;
      })
      .addCase(getFooterDatareq.fulfilled, (state, action) => {
        state.loading = false;
        console.log("footer action.payload", action.payload.footers);
        state.footerPageData = action.payload;
        state.contacts = action.payload.footers[0]
        state.error = null;
      })
      .addCase(getFooterDatareq.pending, (state, action) => {
        state.loading = true;
      })
  },
});

export default footerSlice.reducer;
